export enum CalendarEventSource {
    local = 0,
    outlook = 1
}
export namespace CalendarEventSource{
    export function getName(value: CalendarEventSource): string {
        switch (value) {
            case CalendarEventSource.local:
                return "local";
            case CalendarEventSource.outlook:
                return "outlook";
            default:
                return "???";
        }
    }
}
